import { render, staticRenderFns } from "./EloadRewards2.vue?vue&type=template&id=473646da"
import script from "./EloadRewards2.vue?vue&type=script&lang=js"
export * from "./EloadRewards2.vue?vue&type=script&lang=js"
import style0 from "./EloadRewards2.vue?vue&type=style&index=0&id=473646da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports